import { render, staticRenderFns } from "./ProjectsControl.vue?vue&type=template&id=2e530248&scoped=true&"
import script from "./ProjectsControl.vue?vue&type=script&lang=js&"
export * from "./ProjectsControl.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsControl.vue?vue&type=style&index=0&id=2e530248&prod&lang=css&"
import style1 from "./ProjectsControl.vue?vue&type=style&index=1&id=2e530248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e530248",
  null
  
)

export default component.exports